import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatOption, MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { Observable, debounceTime, distinctUntilChanged, of, startWith, switchMap, tap } from 'rxjs';

@Component({
    selector: 'vendor-autocomplete',
    templateUrl: './vendor-autocomplete.component.html',
    styleUrls: ['./vendor-autocomplete.component.less'],
    standalone: true,
    imports: [
        MatFormFieldModule,
        NgIf,
        MatInputModule,
        MatAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyModule,
        NgFor,
        MatOptionModule,
        MatIconModule,
        AsyncPipe,
    ],
})
export class VendorAutocompleteComponent extends FieldType<FormlyFieldConfig> implements OnInit {
	get control(): UntypedFormControl {
		return this.formControl as UntypedFormControl;
	}
	filter: Observable<any>;
	inputFormControl = new UntypedFormControl('');
	filteredVendors: any[];

	constructor() {
		super();
	}

	public ngOnInit(): void {
		if (this.value !== null) {
			this.inputFormControl.setValue(this.value.VendorName);
		}
		this.filter = this.inputFormControl.valueChanges.pipe(
			startWith(this.value ? this.value.VendorName : ''),
			distinctUntilChanged(),
			debounceTime(500),
			switchMap((search: object | string) => {
				if (typeof search !== 'object') {
					return this.props.filter(search, this.inputFormControl.value).pipe(
						tap((vendors: any[]) => {
							this.filteredVendors = vendors;
						})
					);
				}
				return of([]);
			})
		);
	}

	removeVendor(): void {
		this.formControl.setValue(null);
		this.inputFormControl.setValue('');
	}

	onOptionChanged(selectedOption: MatOption): void {
		const selectedValue = selectedOption.value;
		if (this.props.onOptionChanged) {
			this.props.onOptionChanged(selectedValue);
		}
		if (this.props.change) {
			this.props.change(this.field);
		}
		this.inputFormControl.setValue(selectedValue.VendorDisplay);
		this.formControl.setValue(selectedValue);
		this.value = selectedValue;
		this.form.markAsDirty();
	}

	onBlur(): void {
		this.formControl.markAllAsTouched();
	}
}
